<template>
  <b-card no-body>
    <b-input-group prepend="">
      <b-form-input
                  id="userNo"
                  type="text"
                  size="16"
                  v-model="form.userNo"
                  required
                  placeholder="ID番号を入力">
      </b-form-input>
      <b-input-group-append>
        <b-btn variant="info" @click="searchByUserNo">検索</b-btn>
      </b-input-group-append>
    </b-input-group>
    <div class="header">
      <b-alert variant="info" :show="message != null">{{message}}</b-alert>
      <b-alert variant="danger" :show="error != null">{{error}}</b-alert>
    </div>
  </b-card>
</template>

<script>
import { Logger } from 'aws-amplify'

const logger = new Logger('userNoField')

export default {
  name: 'UserNoField',
  data () {
    return {
      loading: null,
      message: null,
      error: null,
      form: {
        userNo: null
      },
      validators: {
        userNo: null
      },
      currentUser: null,
      unregisteredUserNo: null
    }
  },
  computed: {
    currentUserGroup () {
      return this.$store.getters.currentUserGroup
    }
  },
  mounted () {
  },
  methods: {
    validate () {
      this.validators.userNo = this.form.userNo
      return this.validators.userNo
    },
    searchByUserNo () {
      logger.debug('userNo=', this.form.userNo)
      if (!this.validate()) {
        return
      }

      this.loading = true
      this.message = null
      this.currentUser = null
      this.unregisteredUserNo = null
      this.error = null
      return this.$store.dispatch('getUserGroup', { groupId: this.currentUserGroup.groupId }).then(userGroup => {
        this.loading = false
        logger.debug(userGroup)
        if (userGroup) {
          let mem = userGroup.members && userGroup.members.find(m => m.userNo === this.form.userNo)
          if (mem) {
            this.onDisplay(mem.user_id)
          } else {
            this.message = 'このID番号は登録されていません。'
          }
        }
      }).catch(err => {
        this.loading = false
        this.message = null
        logger.error(err)
        this.error = err.message || err
      })
    },
    onDisplay (userId) {
      this.$router.push({ path: '/usergroups/' + this.currentUserGroup.groupId + '/users/' + userId })
    }
  }
}
</script>

<style scoped>
.scanner-wrapper {
  width: 100%;
  border-left: 1px solid grey;
  border-right: 1px solid grey;
}
.camera-frame {
  border: 1px solid red;
  max-width: 600px;
  max-height: 480px;
  display: block;
}
.register_wrapper {
  width: 100%;
  padding: 1rem 0;
}
</style>
